import { userConstants } from '../constants'

const initialState = []

export default function (users = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case userConstants.RETRIEVE_USERS:
      return payload
    case userConstants.SEARCH_USER:
      return payload
    default:
      return users
  }
}
